import { render } from "./CapacitacionPage.vue?vue&type=template&id=214a4f4c&scoped=true"
import script from "./CapacitacionPage.vue?vue&type=script&lang=js"
export * from "./CapacitacionPage.vue?vue&type=script&lang=js"

import "./CapacitacionPage.vue?vue&type=style&index=0&id=214a4f4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214a4f4c"]])

export default __exports__